import React from 'react';
import { ChevronLeftIcon, ChevronRightIcon } from "@heroicons/react/24/outline";
import logo from '../assets/hellomoov.png';

export default function SidebarHeader({ isSidebarOpen, toggleSidebar }) {
    return (
        <div className={`
            relative flex items-center 
            ${isSidebarOpen ? "justify-center" : "flex-col justify-center gap-4"} 
            py-4 mb-2 transition-all
        `}>
            
            {/* LOGO */}
            <div className="flex items-center justify-center transition-transform duration-300">
                <img
                    src={logo}      
                    alt="Logo"
                    className={`object-contain transition-all duration-300 ${isSidebarOpen ? 'h-10' : 'h-8'}`}
                />
            </div>

            {/* BOUTON TOGGLE */}
            <button 
                onClick={toggleSidebar}
                className={`
                    p-1.5 rounded-md hover:bg-blue-gray-50 text-blue-gray-500 transition-colors border border-transparent hover:border-blue-gray-100
                    ${isSidebarOpen ? "absolute right-2" : ""} 
                `}
                
                title={isSidebarOpen ? "Réduire" : "Agrandir"}
            >
                {isSidebarOpen ? (
                     <ChevronLeftIcon className="h-5 w-5" />
                ) : (
                     <ChevronRightIcon className="h-5 w-5" />
                )}
            </button>
        </div>
    );
}